export default "__VITE_ASSET__kQFIadCf__"